<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row>
        <el-form-item prop="approvalComments">
          <el-input
            v-model="formData.approvalComments"
            :placeholder="$l('form_placeholder_approvalComments')"
            type="textarea"
            :rows="6"
            maxlength="200"
            show-word-limit
            ref="approvalCommentsInput"
          />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { amzReplenishmentDetailCode: { type: String, default: '' } },
  data() {
    return {
      formData: { approvalComments: '' },
      rules: {
        approvalComments: [
          {
            required: true,
            message:
              this.$l('form_placeholder_approvalComments') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.$refs.approvalCommentsInput.focus()
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const confirm = await this.$confirm(
        this.$l('tips_notReplenish') ||
          '是否确认不补货？确认后将会清空返答数据！',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const params = {
        amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        ...this.formData,
      }
      const res = await this.$api
        .ecomAmzReplenishmentDetailNotReplenishApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.message_text_operationFailed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.message_text_operationSucceeded'),
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('close')
    },
    cancel() {
      const { approvalComments } = this.formData
      if (!approvalComments) return this.$emit('cancel')
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.confirm()
        })
        .catch((action) => {
          if (action === 'cancel') this.$emit('cancel')
        })
    },
  },
}
</script>
